import React from 'react';

import { ApolloClient } from 'apollo-client';
import { setContext } from '@apollo/link-context';
import { createHttpLink } from 'apollo-link-http';
import { ApolloProvider } from '@apollo/react-hooks';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { useAuth0 } from '@iso/config/react-auth0-spa';

import { typeDefs } from './apollo/schema';
import { resolvers, defaults } from './apollo/resolvers';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_ENPOINT,
});

const cache = new InMemoryCache();

const AuthorizedApolloProvider = ({ children }) => {
  const { getTokenSilently } = useAuth0();

  const authLink = setContext(async (_, { headers }) => {
    const token = await getTokenSilently();

    return {
      headers: {
        ...headers,
        authorization: token ? `${token}` : ' ',
      },
    };
  });

  const apolloClient = new ApolloClient({
    cache,
    typeDefs,
    resolvers,
    name: 'soaringlioness',
    connectToDevTools: true,
    link: authLink.concat(httpLink),
  });

  cache.writeData({
    data: defaults,
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default AuthorizedApolloProvider;
